/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class VisDnDAPI
 * @hideconstructor
 *
 * @classdesc Handles drag and drop of metadata onto a viaualization vis recommender or vis slot view.
 */
define([
], (
) => {

	return class VisDnDAPI {
		/**
		 * @public
		 * @function VisDnDAPI#registerProviders
		 * @param {String} targetType type of the drop target
		 * @param {DnDProvider[]} array of product-specific Providers (eg: VisDnDLiveWidgetProvider, VisDnDColumnToSlotProvider etc.)
		 */
		registerProviders() {}

		/**
		 * @public
		 * @function VisDnDAPI#accepts
		 * @param {Object} source the drag source object
		 * @param {Object} target the drop target object
		 * @return true if this content can accept this payload.
		 * @description process the on drop action of drag and drop
		 */
		accepts() {}

		/**
		 * @public
		 * @function VisDnDAPI#onDrop
		 * @param {Object} source the drag source object
		 * @param {Object} target the drop target object
		 * @description process the on drop action of drag and drop
		 */
		onDrop() {}
	};
});
